<template>
  <div :class="classes">
    <v-select
      v-if="isSelect"
      v-model="computedValue"
      :disabled="disabled"
      :items="items"
      item-text="description"
      item-value="id"
      :placeholder="placeholder"
      type="text"
      :style="`width: ${getWidth()}`"
      class="input-element"
      @input="onSearch"
      solo
      dense
      flat
      hide-details
    ></v-select>
    <input
      v-if="!isdate && !isdateRange && !isSelect"
      v-model="computedValue"
      :disabled="disabled"
      :placeholder="placeholder"
      type="text"
      :style="`width: ${getWidth()}`"
      class="input-element"
      @keyup.13="onSearch"
      :id="id"
    />
    <datepicker
      v-if="isdate"
      v-model="computedValue"
      :disabled="disabled"
      :placeholder="placeholder"
      :format="customFormatter"
      :style="`width: ${getWidth()}`"
      type="date"
      class="input-element"
      @keyup.13="onSearch"
      @input="onSearch"
    />
    <date-range
      v-if="isdateRange"
      v-model="computedValue"
      :disabled="disabled"
      :placeholder="placeholder"
      :format="customFormatter"
      :style="`width: ${getWidth()}`"
      type="date"
      class="input-element"
      @onChange="onSearch"
    ></date-range>

    <div class="bx-search-action">
      <span v-if="!searchMode" class="bx-search-ico" @click="onSearch"></span>
      <span v-if="searchMode" class="bx-cancel-ico" @click="onCancel"></span>
    </div>
  </div>
</template>
<script>
import DateRange from "@/components/dialogs/DateRange.vue";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
export default {
  name: "bx-search",
  components: {
    Datepicker,
    DateRange
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "100px"
    },
    value: {
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    isdate: {
      type: Boolean,
      default: false
    },
    isdateRange: {
      type: Boolean,
      default: false
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    error: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedDate: null,
      newValue: this.value,
      searchMode: this.value
    };
  },
  watch: {
    /**
     * When v-model change, set internal value.
     */
    // value(value) {
    //   this.newValue = value;
    //   if (value) {
    //     this.searchMode = true;
    //     this.onSearch();
    //   } else {
    //     this.searchMode = false;
    //     this.onCancel();
    //   }
    // }
  },
  computed: {
    classes() {
      const classes = ["bx-search"];
      if (this.error) {
        classes.push("bx-search-error");
      }
      return classes;
    },
    computedValue: {
      get() {
        return this.newValue;
      },
      set(value) {
        this.newValue = value;
        this.$emit("input", value);
      }
    }
  },
  methods: {
    getWidth() {
      return `${(this.placeholder.length + 4) * 10}px`;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    onCancel() {
      if (this.isdateRange) {
        this.searchMode = false;
        this.computedValue = {};
        this.$emit("search", this.computedValue);
      } else {
        this.searchMode = false;
        this.computedValue = "";
        this.$emit("search", this.computedValue);
      }
    },
    onSearch() {
      if (this.isdate && typeof this.computedValue === "object") {
        this.computedValue = moment(this.computedValue).format("YYYY-MM-DD");
      }
      if (this.computedValue === "") {
        this.searchMode = false;
      } else {
        this.searchMode = true;
      }
      this.$emit("search", this.computedValue);
    }
  },
  mounted() {
    try {
      let datePicker = document.getElementsByClassName(
        "vdp-datepicker__calendar"
      )[0];
      let tableWrapper = document.getElementsByClassName("table-wrapper")[0];
      tableWrapper && tableWrapper.appendChild(datePicker);
    } catch (error) {
      // console.error(error)
    }
  }
};
</script>

<style>
.vdp-datepicker__calendar {
  top: 10%;
  left: 35%;
}
@media screen and (max-width: 767px) {
  .vdp-datepicker__calendar {
    left: 0;
  }
}
</style>
